// import React from "react";
// import Select from "../../../form/select/Select";

// const fontOptions = [
//   { value: "Roboto", label: "Roboto" },
//   { value: "Montserrat", label: "Montserrat" },
//   { value: "Open Sans", label: "Open Sans" },
//   { value: "Lato", label: "Lato" },
//   { value: "Poppins", label: "Poppins" },
// ];
// const ThemeStylesEditor = ({ values, setFieldsValue }) => {
//   const handleColorChange = (key, value) => {
//     setFieldsValue({
//       styles: {
//         ...values.styles,
//         [key]: value,
//       },
//     });
//   };

//   const handleFontChange = (key, value) => {
//     setFieldsValue({
//       fonts: {
//         ...values.fonts,
//         [key]: value,
//       },
//     });
//   };

//   const renderColorField = ({ label, key }) => (
//     <div key={key} className="flex flex-col gap-1">
//       <label className="text-sm font-medium text-gray-700">{label}</label>
//       <div className="flex items-center gap-2">
//         <input
//           type="text"
//           placeholder="#hexcode"
//           value={values.styles?.[key] || ""}
//           onChange={(e) => handleColorChange(key, e.target.value)}
//           className="w-full border border-gray-300 rounded px-2 py-1 text-sm"
//         />
//         <input
//           type="color"
//           value={values.styles?.[key] || "#ffffff"}
//           onChange={(e) => handleColorChange(key, e.target.value)}
//           className="w-10 h-10 p-0 border-none cursor-pointer"
//         />
//       </div>
//     </div>
//   );

//   return (
//     <div className="space-y-10 p-4">
//       {/* Basic Styles */}
//       <div className="relative">
//         <h2 className="text-xl font-bold text-gray-800 mb-4 font-Montserrat">
//           Basic Styles
//         </h2>
//         <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 max-w-2xl">
//           {[
//             { label: "Background", key: "background" },
//             { label: "Text", key: "text" },
//             { label: "Ticket button colour", key: "ticketButtonColour" },
//             { label: "Ticket button text", key: "ticketButtonText" },
//             { label: "Borders", key: "borders" },
//           ].map(renderColorField)}
//         </div>
//       </div>

//       {/* Header Styles */}
//       <div className="relative">
//         <h2 className="text-xl font-bold text-gray-800 mb-4 font-Montserrat">
//           Header Styles
//         </h2>
//         <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 max-w-2xl">
//           {[
//             { label: "Background", key: "headerBackground" },
//             { label: "Text", key: "headerText" },
//             { label: "Buy ticket button colour", key: "buyButtonColour" },
//             { label: "Buy ticket button text", key: "buyButtonText" },
//           ].map(renderColorField)}
//         </div>
//       </div>

//       {/* Custom Fonts */}
//       <div className="relative">
//         <h2 className="text-xl font-bold text-gray-800 mb-4 font-Montserrat">
//           Custom Fonts
//         </h2>
//         <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 max-w-2xl">
//           <Select
//             label="Heading Font"
//             placeholder="Select Heading Font"
//             dropdownData={fontOptions}
//             selectedValue={values.fonts?.heading}
//             onChange={(value) => handleFontChange("heading", value)}
//             className="text-gray-800 bg-white" // <-- Ensures selected text is visible
//             dropdownClassName="text-gray-800 bg-white"
//           />
//           <Select
//             label="Body Font"
//             placeholder="Select Body Font"
//             dropdownData={fontOptions}
//             selectedValue={values.fonts?.body}
//             onChange={(value) => handleFontChange("body", value)}
//           />
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ThemeStylesEditor;

import React from "react";
import Select from "../../../form/select/Select";
import { useTranslation } from "react-i18next";

const fontOptions = [
  { value: "Roboto", label: "Roboto" },
  { value: "Montserrat", label: "Montserrat" },
  { value: "Open Sans", label: "Open Sans" },
  { value: "Lato", label: "Lato" },
  { value: "Poppins", label: "Poppins" },
];

const ThemeStylesEditor = ({
  values,
  setFieldsValue = () => {},
  resetStyle = () => {},
}) => {
  const { t } = useTranslation();

  const getValue = (styleArray, key) => {
    if (Array.isArray(styleArray)) {
      return styleArray?.find((item) => item.key === key)?.value || "";
    } else {
      return;
    }
  };

  const updateStyleArray = (arrayName, key, value) => {
    const updatedArray = values.styles[arrayName]?.some(
      (item) => item.key === key
    )
      ? values.styles[arrayName].map((item) =>
          item.key === key ? { ...item, value } : item
        )
      : [...(values.styles[arrayName] || []), { key, value }];

    setFieldsValue({
      styles: {
        ...values.styles,
        [arrayName]: updatedArray,
      },
    });
  };

  const handleColorChange = (arrayName, key, value) => {
    updateStyleArray(arrayName, key, value);
  };

  const handleFontChange = (fontKey, value) => {
    updateStyleArray("customFonts", fontKey, value);
  };

  const renderColorField = ({ label, key, arrayName }) => {
    return (
      <div key={key} className="flex flex-col gap-1">
        <label className="text-sm font-medium text-gray-700">{label}</label>
        <div className="flex items-center gap-2">
          <input
            type="text"
            placeholder="#hexcode"
            value={getValue(values.styles[arrayName], key) || "#ffffff"}
            onChange={(e) => handleColorChange(arrayName, key, e.target.value)}
            className="w-full border border-gray-300 rounded px-2 py-1 text-sm"
          />
          <input
            type="color"
            value={getValue(values.styles[arrayName], key) || "#ffffff"}
            onChange={(e) => handleColorChange(arrayName, key, e.target.value)}
            className="w-10 h-10 p-0 border-none cursor-pointer"
          />
        </div>
      </div>
    );
  };

  return (
    <div className="space-y-10 md:p-4">
      {/* Basic Styles */}
      <div className="relative">
        <div className="flex items-center justify-between">
          <h2 className="text-xl font-bold text-deep-purple mb-4 font-Montserrat">
            {t("Basic Styles")}
          </h2>
          <button
            type="button"
            onClick={() => resetStyle({ type: "basicStyle" })}
            className="relative flex border border-transparent justify-center items-center gap-2 text-white font-semibold text-base h-9 md:h-12 px-4 md:px-6 rounded-full bg-primary-gradient hover:opacity-90 transition-all duration-300"
          >
            {t("Reset")}
          </button>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 max-w-2xl">
          {[
            {
              label: t("Background"),
              key: "background",
              arrayName: "basicStyle",
            },
            { label: t("Text"), key: "text", arrayName: "basicStyle" },
            {
              label: t("Button colour"),
              key: "buttonColour",
              arrayName: "basicStyle",
            },
            {
              label: t("Button text"),
              key: "buttonText",
              arrayName: "basicStyle",
            },
            // { label: "Borders", key: "borders", arrayName: "basicStyle" },
          ].map(renderColorField)}
        </div>
      </div>

      {/* Info Styles */}
      <div className="relative">
        <div className="flex items-center justify-between">
          <h2 className="text-xl font-bold text-deep-purple mb-4 font-Montserrat">
            {t("Info Styles")}
          </h2>
          <button
            type="button"
            onClick={() => resetStyle({ type: "infoStyle" })}
            className="relative flex border border-transparent justify-center items-center gap-2 text-white font-semibold text-base  h-9 md:h-12 px-4 md:px-6 rounded-full bg-primary-gradient hover:opacity-90 transition-all duration-300"
          >
            {t("Reset")}
          </button>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 max-w-2xl">
          {[
            {
              label: t("Background"),
              key: "background",
              arrayName: "infoStyle",
            },
            { label: t("Text"), key: "text", arrayName: "infoStyle" },
            {
              label: t("Button colour"),
              key: "buttonColour",
              arrayName: "infoStyle",
            },
            {
              label: t("Button text colour"),
              key: "buttonText",
              arrayName: "infoStyle",
            },
          ].map(renderColorField)}
        </div>
      </div>

      {/* Header Styles */}
      <div className="relative">
        <div className="flex items-center justify-between">
          <h2 className="text-xl font-bold text-deep-purple mb-4 font-Montserrat">
            {t("Header Styles")}
          </h2>
          <button
            type="button"
            onClick={() => resetStyle({ type: "headerStyle" })}
            className="relative flex border border-transparent justify-center items-center gap-2 text-white font-semibold text-base  h-9 md:h-12 px-4 md:px-6 rounded-full bg-primary-gradient hover:opacity-90 transition-all duration-300"
          >
            {t("Reset")}
          </button>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 max-w-2xl">
          {[
            {
              label: t("Background"),
              key: "background",
              arrayName: "headerStyle",
            },
            { label: t("Text"), key: "text", arrayName: "headerStyle" },
            // {
            //   label: "Button colour",
            //   key: "buttonColour",
            //   arrayName: "headerStyle",
            // },
            // {
            //   label: "Button text colour",
            //   key: "buttonText",
            //   arrayName: "headerStyle",
            // },
          ].map(renderColorField)}
        </div>
      </div>

      {/* Searchbar Styles */}
      <div className="relative">
        <div className="flex items-center justify-between">
          <h2 className="text-xl font-bold text-deep-purple mb-4 font-Montserrat">
            {t("Searchbar Styles")}
          </h2>
          <button
            type="button"
            onClick={() => resetStyle({ type: "searchBarStyle" })}
            className="relative flex border border-transparent justify-center items-center gap-2 text-white font-semibold text-base  h-9 md:h-12 px-4 md:px-6 rounded-full bg-primary-gradient hover:opacity-90 transition-all duration-300"
          >
            {t("Reset")}
          </button>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 max-w-2xl">
          {[
            {
              label: t("Background"),
              key: "background",
              arrayName: "searchBarStyle",
            },
          ].map(renderColorField)}
        </div>
      </div>

      {/* Custom Fonts */}
      {/* <div className="relative">
        <h2 className="text-xl font-bold text-gray-800 mb-4 font-Montserrat">
          Custom Fonts
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 max-w-2xl">
          <Select
            label="Heading Font"
            placeholder="Select Heading Font"
            dropdownData={fontOptions}
            selectedValue={getValue(values.styles?.customFonts, "headingFont")}
            onChange={(value) => handleFontChange("headingFont", value)}
          />
          <Select
            label="Body Font"
            placeholder="Select Body Font"
            dropdownData={fontOptions}
            selectedValue={getValue(values.styles?.customFonts, "bodyFont")}
            onChange={(value) => handleFontChange("bodyFont", value)}
          />
        </div>
      </div> */}
    </div>
  );
};

export default ThemeStylesEditor;
